import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/pool-volume-calculator',
  component: () => import('../../routes/PoolVolumeCalculator.svelte'),
  card: {
    id: 'pool-volume-calculator',
    title: 'Pool Volume Calculator',
    description: 'Calculate the volume of your pool in gallons, liters, or cubic feet to determine chemical dosages and heating costs.',
    icon: 'pool',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/pool-volume-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Pool Volume Calculator – Calculate Gallons, Liters & Cubic Feet',
    description: 'Free pool volume calculator. Enter your pool dimensions to find total volume in gallons, liters, or cubic feet for accurate chemical dosing, heater sizing, and water treatment.',
  },
};

export default meta;
